<template>
  <article class="info-box-salary" id="right-salary">
    <h6 class="info-box-salary__title">
      * Har rätt lön registerats?
    </h6>

    <div class="info-box-salary__values">
      <div class="info-box-salary__value">
        <p>Din angivna lön idag</p>
        <p class="info-box-salary__value-number">
          {{ salaries.salary }} kr/mån
        </p>
      </div>

      <p class="info-box-salary__equals">==</p>

      <div class="info-box-salary__value">
        <p>Registrerad lön hos försäkringsbolag</p>
        <p
          class="info-box-salary__value-number"
          :class="wrongSalary ? 'info-box-salary--wrong-salary' : ''"
        >
          <span v-if="salaries.fskSalary === 0 || salaries.fskSalary == null">
            Ingen lön registrerad.
          </span>
          <span v-else>
            {{ salaries.fskSalary }} kr/mån
          </span>
        </p>
      </div>
    </div>

    <p class="info-box-salary__reaction">
      <span
        class="info-box-salary--wrong-salary"
        v-if="wrongSalary"
      >
        Inläsning av företagstecknade försäkringar pågår.
      </span>
      <span class="info-box-salary__reaction--yes" v-else> Ja! Allt ser ut att vara i sin ordning! </span>
    </p>
  </article>
</template>

<script>
export default {
  name: 'InfoBoxSalary',
  props: [ 'wrongSalary', 'salaries' ],
}
</script>

<style lang="scss" scoped>
.info-box-salary {
  background-color: $light;
  padding: 3rem;
  border-radius: $borderRadius;
  margin: 2rem 0;

  &__values {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 3rem 0;

    @include breakpoints(medium) {
      flex-direction: row;
      justify-content: space-evenly;
    }
  }

  &__value {
    width: 100%;

    &-number {
      background-color: #DADAD4;
      padding: .5rem 0;
      margin-top: .5rem;
      width: 100%;
      text-align: center;

      span {
        font-size: 1rem;
      }
    }

    @include breakpoints(medium) {
      width: 40%;
    }
  }

  &__equals {
    margin: 1rem;

    @include breakpoints(medium) {
      margin: auto;
    }
  }

  &--wrong-salary {
    span {
      color: red;
    }
  }

  &__reaction {
    text-align: center;
    color: $green;
  }
}
</style>